import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";

// (2026-10) PDF y Excel de los listados del CRM. Reciben lo que ya está
// filtrado en pantalla (sector, línea, etapa, búsqueda...) y una línea con los
// filtros aplicados, para que el archivo diga qué se exportó.

const AZUL = [0, 58, 92];

export const dineroCrm = (n) =>
  "$" + Number(n || 0).toLocaleString("es-MX", { maximumFractionDigits: 0 });

export const fechaCortaCrm = (f) => {
  const [a, m, d] = String(f || "").slice(0, 10).split("-");
  return a && m && d ? `${d}/${m}/${a}` : "";
};

// Texto del filtro de sector para encabezados y nombres de archivo
export const textoFiltroSector = (filtro) =>
  filtro === "sin" ? "Sin sector" : filtro || "Todos los sectores";

const sinDatos = (filas) => {
  if (filas.length) return false;
  Swal.fire("Sin datos", "No hay registros con los filtros actuales", "warning");
  return true;
};

// columnas: [{ titulo, ancho?, alinear? }]; filas: arreglos en el mismo orden
export function pdfCrm({ titulo, filtros, columnas, filas, archivo }) {
  if (sinDatos(filas)) return;
  const doc = new jsPDF("landscape");
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const ML = 12;

  doc.setFont(undefined, "bold").setFontSize(16).setTextColor(...AZUL);
  doc.text(titulo.toUpperCase(), ML, 16);
  doc.setFont(undefined, "normal").setFontSize(10).setTextColor(60, 60, 60);
  doc.text(filtros, ML, 23);
  doc.text(
    `Fecha: ${fechaCortaCrm(new Date().toISOString())}   ·   ${filas.length} registro(s)`,
    pageW - ML,
    16,
    { align: "right" }
  );

  const columnStyles = {};
  columnas.forEach((c, i) => {
    columnStyles[i] = {};
    if (c.ancho) columnStyles[i].cellWidth = c.ancho;
    if (c.alinear) columnStyles[i].halign = c.alinear;
  });
  doc.autoTable({
    startY: 28,
    margin: { left: ML, right: ML, bottom: 16 },
    theme: "grid",
    head: [columnas.map((c) => c.titulo.toUpperCase())],
    body: filas,
    styles: { fontSize: 8, cellPadding: 1.5, valign: "middle" },
    headStyles: { fillColor: AZUL, textColor: 255, halign: "center" },
    columnStyles,
    // un renglón no se parte entre dos hojas
    rowPageBreak: "avoid",
  });

  const n = doc.internal.getNumberOfPages();
  for (let i = 1; i <= n; i++) {
    doc.setPage(i);
    doc.setFontSize(8).setTextColor(100, 100, 100);
    doc.text(`${titulo} · ${filtros}`, ML, pageH - 7);
    doc.text(`Página ${i} de ${n}`, pageW - ML, pageH - 7, { align: "right" });
  }
  doc.save(`${archivo}.pdf`);
}

// hojas: [{ nombre, columnas: [titulos], filas: [[...]] }]
export function excelCrm({ archivo, hojas }) {
  if (sinDatos(hojas[0]?.filas || [])) return;
  new ExportJsonExcel({
    fileName: archivo,
    datas: hojas.map((h) => {
      const claves = h.columnas.map((_, i) => `c${i}`);
      return {
        sheetName: h.nombre,
        sheetFilter: claves,
        sheetHeader: h.columnas,
        sheetData: h.filas.map((f) =>
          claves.reduce((o, k, i) => ({ ...o, [k]: f[i] }), {})
        ),
      };
    }),
  }).saveExcel();
}
